import React, { useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { Plus } from 'lucide-react';
import { Tab } from '@headlessui/react';
import Img from '../../components/Img';
import { STRATEGIES_MAX_COUNT } from '../../utils/const';
import SvgIcon from '../../components/SvgIcon';
import { getSvgGKGTabs } from '../../utils/helpers/getSvgGKGTabs';
import { getRenderBlockGKG } from '../../utils/helpers/getRenderBlockGKG';
import Button from '../../components/Button';

export default function GKGTabsTemplates({
  content,
  className,
  showIcons = true,
  editMode = false,
  portfolioWebMode = false,
  firstColor,
  secondColor,
  textColor,
  tabColor,
  titleTabsColor,
  backgroundBlock,
  borderBlockColor,
  content: {
    icon,
    title,
    getStrategies,
    keepStrategies,
    growStrategies,
    referralStrategies,
  },
  textStyle,
}) {
  const [tab, setTab] = useState(0);
  const {
    getKeepGrow: { addStrategy, updateStrategy, removeStrategy },
  } = useDispatch();
  const tabs = ['get', 'keep', 'grow', 'referral'];
  const data = [
    getStrategies,
    keepStrategies,
    growStrategies,
    referralStrategies,
  ];

  return (
    <div
      className={classNames('bmc-page-gkgtabs', className, {
        'bmc-page-gkgtabs--portfolio-web': portfolioWebMode,
        'bmc-page-gkgtabs--portfolio': editMode,
      })}
    >
      {title && (
        <div className="bmc-page-gkgtabs-header">
          <div className="bmc-page-gkgtabs-header-icon">
            <Img src={icon} />
          </div>
          <div className="bmc-page-gkgtabs-header-title custom-font-title">
            {title}
          </div>
        </div>
      )}
      <Tab.Group selectedIndex={tab} onChange={setTab}>
        <Tab.List className="bmc-page-gkgtabs-tabs">
          {tabs.map((tabName, index) => (
            <Tab
              key={index}
              className={classNames('bmc-page-gkgtabs-tabs-tab', {
                'bmc-page-gkgtabs-tabs-tab--active': tab === index,
              })}
            >
              {({ selected }) => (
                <>
                  {showIcons && (
                    <div className="bmc-page-gkgtabs-tabs-tab-icon">
                      <div
                        className="svg-funCRget flex justify-center"
                        style={{ fill: secondColor, stroke: secondColor }}
                      >
                        {tab === index ? (
                          getSvgGKGTabs(index, firstColor)
                        ) : (
                          <SvgIcon name="funCRget" />
                        )}
                      </div>
                    </div>
                  )}

                  <div
                    className={classNames(
                      'bmc-page-gkgtabs-tabs-tab-title bmc-page-gkgtabs-tabs-tab-title-colourful custom-font-body',
                      textStyle,
                      selected && 'bmc-page-gkgtabs-tabs-tab--active',
                    )}
                    style={{ color: tabColor, borderBottomColor: tabColor }}
                  >
                    {content[tabName]}
                  </div>
                </>
              )}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          {tabs.map((tabName, index) => (
            <Tab.Panel
              key={index}
              className={classNames(
                'bmc-page-gkgtabs-tabs-tab-title bmc-page-gkgtabs-tabs-tab-title-colourful custom-font-body mt-6',
                textStyle,
                {
                  'bmc-page-gkgtabs-tabs-tab--active': tab === index,
                },
              )}
              style={{ color: tabColor, borderBottomColor: tabColor }}
            >
              <div className="flex flex-col lg:flex-row">
                {getRenderBlockGKG(
                  data[index],
                  editMode,
                  tabName,
                  updateStrategy,
                  removeStrategy,
                  backgroundBlock,
                  borderBlockColor,
                  titleTabsColor,
                  textColor,
                  textStyle,
                )}

                {editMode && data[index].length < STRATEGIES_MAX_COUNT && (
                  <Button
                    className="flex w-1/3 flex-1"
                    variant="outline"
                    style={{ background: backgroundBlock }}
                    onClick={() =>
                      addStrategy({
                        collectionName: `${tabs[index]}Strategies`,
                      })
                    }
                  >
                    <Plus className="w-8 h-auto" />
                  </Button>
                )}
              </div>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
